import React from 'react';
import { Localizer } from 'services/Localizer';
import { DropdownField, TextBoxField } from 'shared/edit/fields';
import { PrivacyTypeOptions } from './types';

export function ShoppingListEditItemFields() {
	return (
		<>
			<div className="roc-row">
				<div className="roc-col-sm-12">
					<TextBoxField label={Localizer('ShoppingListName')} name="name" isRequired />
				</div>
				<div className="roc-col-sm-5">
					<DropdownField
						label={Localizer('Privacy')}
						name="privacy"
						isRequired
						options={PrivacyTypeOptions}
						addSelectOption={false}
					/>
				</div>
			</div>
		</>
	);
}
